
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLigthSleet as ObiLightningLigthSleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-ligth-sleet.js';
 
 
 

 
 export const ObiLightningLigthSleet = createComponent({
   react: React,
   tagName: 'obi-lightning-ligth-sleet',
   elementClass: ObiLightningLigthSleetElement,
   events: {
     
   }
  });
 
 